import { TRANSLATION, Yup } from "@/imports-files/common/common";

export const UNSUCCESSFUL_EMAIL_VALUES = {
  email: {
    cc: [],
    subject: "",
    email_body: "",
  },
};

export const UNSUCCESSFUL_EMAIL_VALIDATION = Yup.object({
  email: Yup.object({}),
});

export const TEXTS = (t) => ({
  active_or_unsuccessful: {
    heading: t("modal:unsuccessful_email"),
  },
  move_candidates: {
    heading: TRANSLATION("candidates:move_candidates:heading"),
  },
  send_sourced_invitation: {
    heading: TRANSLATION("candidates:send_sourced_invitation:heading"),
  },
  add_interview: {
    heading: t('modal:email_modal:interview_email_scheduled')
    },
  setup_kanban_interview: {
    heading: t('modal:email_modal:interview_email_scheduled')
  },
  To: TRANSLATION("modal:email_modal:to"),
  Email_Body: TRANSLATION("modal:email_modal:email_body"),
  Subject: TRANSLATION("modal:email_modal:subject"),
  CC: TRANSLATION("modal:email_modal:cc"),
  Save: TRANSLATION("modal:email_modal:save"),
});
